import type {
  ComponentMode,
  FileOwnerType,
  ProductComment,
  ProductCommentStatus,
} from 'types';

interface State extends ProductComment {
  mode: ComponentMode;
  ownerType: FileOwnerType;
  defaultStatus: ProductCommentStatus;
  defaultName: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_PRODUCT_COMMENT_CONTENT';
      payload: Pick<typeof initialState, 'content'>;
    }
  | {
      type: 'UPDATE_PRODUCT_COMMENT_REPLIES';
      payload: Pick<typeof initialState, 'replies'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
